import styled, { css } from 'styled-components';
import { darken, lighten, rgba } from 'polished';

import { c7A35CB, cFFFFFF } from '#/colors';

export interface ButtonProps {
  readonly variant?: 'solid' | 'outline';
}

const DEFAULT_VARIANT = 'solid';

const Button = styled.button<ButtonProps>`
  ${({ variant = DEFAULT_VARIANT }) => {
    switch (variant) {
      case 'solid':
        return css`
          background-color: ${c7A35CB};
          border: none;
          color: ${cFFFFFF};
        `;
      case 'outline':
        return css`
          background-color: transparent;
          border: 1px solid ${c7A35CB};
          color: ${rgba(cFFFFFF, 0.7)};
        `;
      // no default
    }
  }}

  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover {
    ${({ variant = DEFAULT_VARIANT }) => {
      switch (variant) {
        case 'solid':
          return css`
            background-color: ${lighten(0.02, c7A35CB)};
          `;
        case 'outline':
          return css`
            border: 1px solid ${lighten(0.02, c7A35CB)};
          `;
        // no default
      }
    }}
  }

  &:active {
    ${({ variant = DEFAULT_VARIANT }) => {
      switch (variant) {
        case 'solid':
          return css`
            background-color: ${darken(0.05, c7A35CB)};
          `;
        case 'outline':
          return css`
            border: 1px solid ${darken(0.05, c7A35CB)};
          `;
        // no default
      }
    }}
  }
`;

export default Button;
